define("SDB.SDBLocations.Phone.View", [
  "sdb_phone_number.tpl",
  "sdb_sidebar_phone_number.tpl",
  "SCView",
  "SDB.SDBLocations.Model",
  "Utils",
], function (
  sdb_phone_number_tpl,
  sdb_sidebar_phone_number_tpl,
  SCViewComponent,
  SDBLocationModel,
  Utils
) {
  "use strict";

  var SCView = SCViewComponent.SCView;

  function SDBPhoneView(options) {
    SCView.call(this);
    this.options = options;
    this.model = SDBLocationModel.getInstance();
    if (options.isSidebar) this.template = sdb_sidebar_phone_number_tpl;
    else this.template = sdb_phone_number_tpl;
    this.events = {
      'click [data-action="tel"]': "handleContact",
      'click [data-action="sms"]': "handleContact",
    };

    this.updateNumber();

    var self = this;
    this.model.on(
      "change:location",
      function () {
        if (self.model.getShoppingExperience() === "online") return;
        self.updateNumber();
        self.render();
      },
      this
    );

    this.model.on(
      "change:shoppingExperience",
      function () {
        if (self.model.getShoppingExperience() !== "online") return;
        self.updateNumber();
        self.render();
      },
      this
    );
  }

  SDBPhoneView.prototype = Object.create(SCView.prototype);
  SDBPhoneView.prototype.constructor = SDBPhoneView;

  SDBPhoneView.prototype.formatPhoneNumber = function formatPhoneNumber(
    phoneNumber
  ) {
    var regex = /\+1(\d{3})(\d{3})(\d{4})/;
    var match = phoneNumber.match(regex);
    if (match) {
      return {
        formatted: "(" + match[1] + ") " + match[2] + "-" + match[3],
        raw: "+1-" + match[1] + "-" + match[2] + "-" + match[3],
      };
    }
  };

  SDBPhoneView.prototype.updateNumber = function updateNumber() {
    var locationSelected = this.model.getSelectedLocation();
    if (this.model.getShoppingExperience() === "online" || !locationSelected)
      locationSelected = this.model.get("onlineLocation");
    if (!locationSelected) {
      this.hasLocation = false;
      return;
    }
    var phoneNumber = locationSelected.phone;
    this.hasLocation = true;
    if (!phoneNumber) return;
    var phoneParts = this.formatPhoneNumber(phoneNumber);
    this.phoneNumber = phoneParts.raw;
    this.phoneNumberFormatted = phoneParts.formatted;
  };

  SDBPhoneView.prototype.handleContact = function handleContact(e) {
    var $target = this.$(e.target);
    var action = $target.data("number");
    window.location.href = action;
  };

  SDBPhoneView.prototype.getContext = function () {
    return {
      hasLocation: this.hasLocation,
      phoneNumber: this.phoneNumber,
      phoneNumberFormatted: this.phoneNumberFormatted,
      isPhoneDevice: Utils.isPhoneDevice(),
    };
  };

  return SDBPhoneView;
});
